export const SupportedLanguages = [
  { code: "fr", name: "Français" },
  { code: "en", name: "English" },
];
